import React, { useCallback } from 'react';
import { fetchDBUDataWithFiltersData } from 'service/service';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';

/**
 * ClusterCountTable component refactored to use AdbFlatTableBase.
 */
const ClusterCountTable = () => {
  const serviceFunc = useCallback((params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, selectedDateInString, exportType,
      sortBy, sortDir
    } = params;
    return fetchDBUDataWithFiltersData({
      startDate,
      endDate,
      env,
      sector,
      location,
      page,
      pageSize,
      filters: apiFilters,
      selectedDateInString,
      workspaceName: undefined,
      exportType,
      sortField: sortBy,
      sortOrder: sortDir
    });
  }, []);

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Cluster Count"
      breadcrumbLabel="Cluster Analytics"
      breadcrumbPath="/databricksADB/clusteranalytics"
      tableType="cluster-count-table"
      preserveFilterKey="cluster_count_table"
      showClusterName={true}
    />
  );
};

export default ClusterCountTable;